import { createWebHistory, createRouter, createWebHashHistory } from "vue-router";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import ProjectManagementPage from "../pages/Dashboard/ProjectManagementPage.vue";
import SupportDeskPage from "../pages/Dashboard/SupportDeskPage.vue";
import LMSCoursesPage from "../pages/Dashboard/LMSCoursesPage.vue";
import CRMSystemPage from "../pages/Dashboard/CRMSystemPage.vue";
import FileManagerPage from "../pages/FileManagerPage.vue";
import ChangelogPage from "../pages/ChangelogPage.vue";
import CalendarPage from "../pages/CalendarPage.vue";
import ChatPage from "../pages/ChatPage.vue";
import ChatGroupPage from "../pages/ChatGroupPage.vue";
import ChatContactPage from "../pages/ChatContactPage.vue";
import LeadsPage from "../pages/CRM/LeadsPage.vue";
import LeadDetailsPage from "../pages/CRM/LeadDetailsPage.vue";
import ContactsListPage from "../pages/CRM/ContactsListPage.vue";
import CustomersListPage from "../pages/CRM/CustomersListPage.vue";
import EmailsPage from "../pages/Emails/EmailsPage.vue";
import ReadEmailPage from "../pages/Emails/ReadEmailPage.vue";
import ProductsGridPage from "../pages/Ecommerce/ProductsGridPage.vue";
import OrdersListPage from "../pages/Ecommerce/OrdersListPage.vue";
import OrderDetailsPage from "../pages/Ecommerce/OrderDetailsPage.vue";
import ShoppingCartPage from "../pages/Ecommerce/ShoppingCartPage.vue";
import CheckoutPage from "../pages/Ecommerce/CheckoutPage.vue";
import CustomersPage from "../pages/Ecommerce/CustomersPage.vue";
import SellersListPage from "../pages/Ecommerce/SellersListPage.vue";
import ManageReviewsPage from "../pages/Ecommerce/ManageReviewsPage.vue";
import RefundPage from "../pages/Ecommerce/RefundPage.vue";
import InvoiceListPage from "../pages/Ecommerce/InvoiceListPage.vue";
import InvoiceDetailsPage from "../pages/Ecommerce/InvoiceDetailsPage.vue";
import OrderTrackingPage from "../pages/Ecommerce/OrderTrackingPage.vue";
import CoursesListPage from "../pages/ELearning/CoursesListPage.vue";
import CoursesGridPage from "../pages/ELearning/CoursesGridPage.vue";
import CourseDetailsPage from "../pages/ELearning/CourseDetailsPage.vue";
import LessonsPreviewPage from "../pages/ELearning/LessonsPreviewPage.vue";
import EditCoursePage from "../pages/ELearning/EditCoursePage.vue";
import ListViewPage from "../pages/SupportDesk/ListViewPage.vue";
import CardViewPage from "../pages/SupportDesk/CardViewPage.vue";
import ContactsPage from "../pages/SupportDesk/ContactsPage.vue";
import TicketPreviewPage from "../pages/SupportDesk/TicketPreviewPage.vue";
import ProjectsListPage from "../pages/Projects/ProjectsListPage.vue";
import ProjectsGridPage from "../pages/Projects/ProjectsGridPage.vue";
import CreateNewProjectPage from "../pages/Projects/CreateNewProjectPage.vue";
import ProjectDetailsPage from "../pages/Projects/ProjectDetailsPage.vue";
import ToDoListPage from "../pages/Projects/ToDoListPage.vue";
import TeamsPage from "../pages/Projects/TeamsPage.vue";
import KanbanPage from "../pages/KanbanPage.vue";
import EventsGridPage from "../pages/Events/EventsGridPage.vue";
import EventDetailsPage from "../pages/Events/EventDetailsPage.vue";
import TimelinePage from "../pages/Social/TimelinePage.vue";
import AboutPage from "../pages/Social/AboutPage.vue";
import ProfileSettingsPage from "../pages/Social/ProfileSettingsPage.vue";
import StarterPage from "../pages/StarterPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import UsersListPage from "@/pages/Users/ListeUserPage.vue";
import PricingPage from "../pages/PricingPage.vue";
import FaqPage from "../pages/FaqPage.vue";
import SwiperSliderPage from "../pages/Miscellaneous/SwiperSliderPage.vue";
import PrivacyPolicyPage from "../pages/Miscellaneous/PrivacyPolicyPage.vue";
import TermsConditionsPage from "../pages/Miscellaneous/TermsConditionsPage.vue";
import FormOverviewPage from "../pages/Forms/FormOverviewPage.vue";
import FormControlPage from "../pages/Forms/FormControlPage.vue";
import FormSelectPage from "../pages/Forms/FormSelectPage.vue";
import FormChecksRadiosPage from "../pages/Forms/FormChecksRadiosPage.vue";
import BlankPage from "../pages/BlankPage.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import ListeCategorieDocumentPage from "@/pages/CategorieDocument/ListeCategoriePage.vue";
import ListeTypeDocumentPage from "@/pages/TypeDocument/ListeTypeDocumentPage.vue";
import ListeTypeOrganisationPage from "@/pages/TypeOrganisation/ListeTypeOrganisationPage.vue";
import ListeOrganisationPage from "@/pages/Organisation/ListeOrganisationPage.vue";
import ListeProfilPage from "@/pages/Profil/ListeProfilPage.vue";
// import ListePrivilegePage from "@/pages/Privilege/ListePrivilegePage.vue";
// import ListeUtilisateurPage from "@/pages/Utilisateur/ListeUtilisateurPage.vue";
import AddParametrePage from "@/pages/Parametre/AddParametrePage.vue";
import ListeAuteurPage from "@/pages/Auteur/ListeAuteurPage.vue";
import ListeTagPage from "@/pages/Tag/ListeTagPage.vue";
import ListeGenrePage from "@/pages/Genre/ListeGenrePage.vue";
import ListeCollectionPage from "@/pages/Collection/ListeCollectionPage.vue";
import ListeMaisonEditionPage from "@/pages/MaisonEdition/ListeMaisonEditionPage.vue";
import ApiService from "@/services/ApiService";
import { useAuthStore } from "@/services/auth";
import ErrorPage from "../pages/ErrorPage.vue";

import AddDocumentPage from "@/pages/Document/AddDocumentPage.vue";
import EditDocumentPage from "@/pages/Document/EditDocumentPage.vue";
import ListeDocumentPage from "@/pages/Document/ListeDocumentPage.vue";
import AddEmpruntPage from "@/pages/Emprunt/AddEmpruntPage.vue";
import EditEmpruntPage from "@/pages/Emprunt/EditEmpruntPage.vue";
import ListeEmpruntPage from "@/pages/Emprunt/ListeEmpruntPage.vue";
import MesEmpruntsPage from "@/pages/Emprunt/MesEmpruntsPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import AddRolePage from "@/pages/Role/AddRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from "@/pages/Users/AddUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import HistoriqueTelechargementPage from "@/pages/Historique/HistoriqueTelechargementPage.vue";
import HistoriqueLecturePage from "@/pages/Historique/HistoriqueLecturePage.vue";
import ListeSecteurPage from "@/pages/Secteur/ListeSecteurPage.vue";
const routes = [
{
  path: "/",
  redirect: "/login",
  component: () => import("@/layouts/MainLayout.vue"),
  meta: {
    middleware: "auth",
  },
  children: [
    {
      path: "/Accueil",
      name: "EcommercePage",
      component: EcommercePage,
    },
    {
      path: "/Categories",
      name: "ListeCategorie",
      component: ListeCategorieDocumentPage,
    },
    
    {
      path: "/documents/ajouter-document",
      name: "AddDocumentPage",
      component: AddDocumentPage,
      meta: {
        title: 'Ajouter un document',
      }
    },
    {
      path: "/documents/liste-document",
      name: "ListeDocumentPage",
      component: ListeDocumentPage,
      meta: {
        title: 'Liste des documents',
      }
    },
    {
      path: "edit-document/:id",
      name: "EditDocumentPage",
      component: EditDocumentPage,
      meta: {
        title: 'Modifier un document',
      }
    },
    {
      path: '/documents/pdf-viewer/:id',
      name: 'pdf-viewer',
      component: () => import('@/components/Document/LecteurDocument.vue'),
      // meta: { requiresAuth: true }
    },

    {
      path: "/emprunts/ajouter-emprunt",
      name: "AddEmpruntPage",
      component: AddEmpruntPage,
      meta: {
        title: 'Ajouter un emprunt',
      }
    },
    {
      path: "/emprunts/liste-emprunt",
      name: "ListeEmpruntPage",
      component: ListeEmpruntPage,
      meta: {
        title: 'Liste des emprunts',
      }
    },
    {
      path: "edit-emprunt/:id",
      name: "EditEmpruntPage",
      component: EditEmpruntPage,
      meta: {
        title: 'Modifier un emprunt',
      }
    },
    {
      path: "/mes-emprunts",
      name: "MesEmpruntsPage",
      component: MesEmpruntsPage,
      meta: {
        title: 'Mes emprunts de documents',
        //requiresAuth: true
      }
    },
    {
      path: "/historique-lecture",
      name: "HistoriqueLecturePage",
      component: HistoriqueLecturePage,
      meta: {
        title: 'Historique de lecture',
        //requiresAuth: true
      }
    },
    {
      path: "/historique-telechargement",
      name: "HistoriqueTelechargementPage",
      component: HistoriqueTelechargementPage,
      meta: {
        title: 'Historique de lecture et téléchargement',
        requiresAuth: true
      }
    },
    {
      path: "/Tag",
      name: "ListeTagPage",
      component: ListeTagPage,
    },
    {
      path: "/Genre",
      name: "ListeGenrePage",
      component: ListeGenrePage,
    },
    {
      path: "/Secteurs",
      name: "ListeSecteurPage",
      component: ListeSecteurPage,
    },
    {
      path: "/Collection",
      name: "ListeCollectionPage",
      component: ListeCollectionPage,
    },
    {
      path: "/Maison-Edition",
      name: "ListeMaisonEditionPage",
      component: ListeMaisonEditionPage,
    },

    {
      path: "/TypeDocument",
      name: "ListeTypeDocumentPage",
      component: ListeTypeDocumentPage,
    },
    {
      path: "/TypeOrganisation",
      name: "ListeTypeOrganisationPage",
      component: ListeTypeOrganisationPage,
    },
    {
      path: "/Organisation",
      name: "ListeOrganisationPage",
      component: ListeOrganisationPage,
    },
    {
        path: "/liste-privileges",
        name: "ListePermissionPage",
        component: ListePermissionPage,
      },
      { 
        path: "/ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
      },
      {
        path: "/modifier-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
      },
      {
        path: "/liste-roles",
        name: "ListeRolePage",
        component: ListeRolePage,
      },
      {
        path: "/ajouter-user",
        name: "AddUserPage",
        component: AddUserPage,
      },
      {
        path: "/view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
      },
      {
        path: "/modifier-user/:id",
        name: "EditUserPage",
        component: EditUserPage,
      },
      {
        path: "/liste-users",
        name: "ListeUserPage",
        component: ListeUserPage,
      },
    {
      path: "/Roles",
      name: "ListeRole",
      component: ListeRolePage,
    },
    {
      path: "/Profils",
      name: "ListeProfil",
      component: ListeProfilPage,
    },
    // {
    //   path: "/Privileges",
    //   name: "ListePrivilege",
    //   component: ListePrivilegePage,
    // },
    // {
    //   path: "/Utilisateurs",
    //   name: "ListeUtilisateur",
    //   component: ListeUtilisateurPage,
    // },
    {
      path: "/Parametres",
      name: "AddParametrePage",
      component: AddParametrePage,
    },
    {
      path: "/Auteur",
      name: "ListeAuteurPage",
      component: ListeAuteurPage,
    },
    {
      path: "/project-management",
      name: "ProjectManagementPage",
      component: ProjectManagementPage,
    },
    {
      path: "/support-desk",
      name: "SupportDeskPage",
      component: SupportDeskPage,
    },
    {
      path: "/lms-courses",
      name: "LMSCoursesPage",
      component: LMSCoursesPage,
    },
    {
      path: "/crm-system",
      name: "CRMSystemPage",
      component: CRMSystemPage,
    },
    {
      path: "/file-manager",
      name: "FileManagerPage",
      component: FileManagerPage,
    },
    {
      path: "/changelog",
      name: "ChangelogPage",
      component: ChangelogPage,
    },
    {
      path: "/calendar",
      name: "CalendarPage",
      component: CalendarPage,
    },
    {
      path: "/chat",
      name: "ChatPage",
      component: ChatPage,
    },
    {
      path: "/chat-group",
      name: "ChatGroupPage",
      component: ChatGroupPage,
    },
    {
      path: "/chat-contact",
      name: "ChatContactPage",
      component: ChatContactPage,
    },
    {
      path: "/leads",
      name: "LeadsPage",
      component: LeadsPage,
    },
    {
      path: "/lead-details",
      name: "LeadDetailsPage",
      component: LeadDetailsPage,
    },
    {
      path: "/crm-contacts",
      name: "ContactsListPage",
      component: ContactsListPage,
    },
    {
      path: "/crm-customers",
      name: "CustomersListPage",
      component: CustomersListPage,
    },
    {
      path: "/emails",
      name: "EmailsPage",
      component: EmailsPage,
    },
    {
      path: "/read-email",
      name: "ReadEmailPage",
      component: ReadEmailPage,
    },
    {
      path: "/catalogue-des-livres",
      name: "ProductsGridPage",
      component: ProductsGridPage,
    },
    {
      path: "/orders",
      name: "OrdersListPage",
      component: OrdersListPage,
    },
    {
      path: "/order-details",
      name: "OrderDetailsPage",
      component: OrderDetailsPage,
    },
    {
      path: "/cart",
      name: "ShoppingCartPage",
      component: ShoppingCartPage,
    },
    {
      path: "/checkout",
      name: "CheckoutPage",
      component: CheckoutPage,
    },
    {
      path: "/customers",
      name: "CustomersPage",
      component: CustomersPage,
    },
    {
      path: "/sellers",
      name: "SellersListPage",
      component: SellersListPage,
    },
    {
      path: "/reviews",
      name: "ManageReviewsPage",
      component: ManageReviewsPage,
    },
    {
      path: "/refund",
      name: "RefundPage",
      component: RefundPage,
    },
    {
      path: "/invoice",
      name: "InvoiceListPage",
      component: InvoiceListPage,
    },
    {
      path: "/invoice-details",
      name: "InvoiceDetailsPage",
      component: InvoiceDetailsPage,
    },
    {
      path: "/order-tracking",
      name: "OrderTrackingPage",
      component: OrderTrackingPage,
    },
    {
      path: "/courses-list",
      name: "CoursesListPage",
      component: CoursesListPage,
    },
    {
      path: "/courses-grid",
      name: "CoursesGridPage",
      component: CoursesGridPage,
    },
    {
      path: "/course-details",
      name: "CourseDetailsPage",
      component: CourseDetailsPage,
    },
    {
      path: "/lessons-preview",
      name: "LessonsPreviewPage",
      component: LessonsPreviewPage,
    },
    {
      path: "/edit-course",
      name: "EditCoursePage",
      component: EditCoursePage,
    },
    {
      path: "/support-desk-list",
      name: "ListViewPage",
      component: ListViewPage,
    },
    {
      path: "/support-desk-card",
      name: "CardViewPage",
      component: CardViewPage,
    },
    {
      path: "/contacts",
      name: "ContactsPage",
      component: ContactsPage,
    },
    {
      path: "/ticket-preview",
      name: "TicketPreviewPage",
      component: TicketPreviewPage,
    },
    {
      path: "/projects-list",
      name: "ProjectsListPage",
      component: ProjectsListPage,
    },
    {
      path: "/projects-grid",
      name: "ProjectsGridPage",
      component: ProjectsGridPage,
    },
    {
      path: "/create-new-project",
      name: "CreateNewProjectPage",
      component: CreateNewProjectPage,
    },
    {
      path: "/project-details",
      name: "ProjectDetailsPage",
      component: ProjectDetailsPage,
    },
    {
      path: "/to-do-list",
      name: "ToDoListPage",
      component: ToDoListPage,
    },
    {
      path: "/projects-teams",
      name: "TeamsPage",
      component: TeamsPage,
    },
    {
      path: "/kanban",
      name: "KanbanPage",
      component: KanbanPage,
    },
    {
      path: "/events",
      name: "EventsGridPage",
      component: EventsGridPage,
    },
    {
      path: "/event-details",
      name: "EventDetailsPage",
      component: EventDetailsPage,
    },
    {
      path: "/social-timeline",
      name: "TimelinePage",
      component: TimelinePage,
    },
    {
      path: "/social-about",
      name: "AboutPage",
      component: AboutPage,
    },
    {
      path: "/profile-settings",
      name: "ProfileSettingsPage",
      component: ProfileSettingsPage,
    },
    {
      path: "/starter",
      name: "StarterPage",
      component: StarterPage,
    },
    {
      path: "/users-list",
      name: "UsersListPage",
      component: UsersListPage,
    },
    {
      path: "/pricing",
      name: "PricingPage",
      component: PricingPage,
    },
    {
      path: "/faq",
      name: "FaqPage",
      component: FaqPage,
    },
    {
      path: "/ui-swiper-slider",
      name: "SwiperSliderPage",
      component: SwiperSliderPage,
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicyPage",
      component: PrivacyPolicyPage,
    },
    {
      path: "/terms-conditions",
      name: "TermsConditionsPage",
      component: TermsConditionsPage,
    },
    {
      path: "/forms-overview",
      name: "FormOverviewPage",
      component: FormOverviewPage,
    },
    {
      path: "/forms-form-control",
      name: "FormControlPage",
      component: FormControlPage,
    },
    {
      path: "/forms-select",
      name: "FormSelectPage",
      component: FormSelectPage,
    },
    {
      path: "/forms-checks-radios",
      name: "FormChecksRadiosPage",
      component: FormChecksRadiosPage,
    },
    {
      path: "/blank-page",
      name: "BlankPage",
      component: BlankPage,
    },
    {
      path: "/logout",
      name: "LogoutPage",
      component: LogoutPage,
    }, 
  ],
},
{
  path: "/",
  redirect: "/login",
  component: () => import("@/layouts/AuthLayout.vue"),
  children: [
    {
      path: "/login",
      name: "LoginPage",
      component: LoginPage,
    },
  ]
},

{ path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },

];

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});


router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  await authStore.verifyAuth();
  if(to.meta.middleware == "auth") {
    ApiService.setHeader();
    if (authStore.isAuthenticated) {
      next();
    } else {
      // next({ name: "LoginPage" });
      next();
    }
  } else {
    next();
  }
  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});


export default router;